import { LAYOUTS, POSITION } from "@voltmoney/types";
import { InputStateToken, KeyboardTypeToken, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { editUserDetails, goBack, handleCloseModal, handleCloseOtpModal, needHelp, resendOtp, verifyOtp } from "./actions";
import { formatFullName, getBankPNGUrl, getContactUsDetails, maskBankSensitiveDetails, maskSensitiveDetails, showUserEditDetailsIcon, } from "../../../configs/utils";
import { Platform } from "react-native";
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
export const template = (profileData, formattedFullName, contactUsDetails, height, showUsersEditIcon, userUpdatedValue, userUpdatedType, isUserUpdateDetailsInProgress) => {
    return {
        layout: {
            id: ROUTE.ACCOUNT_DETAILS,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                { id: "accountDetailsDC", type: WIDGET.ACCOUNT_DETAILS_PAGE },
            ],
        },
        datastore: {
            accountDetailsDC: {
                height: height,
                needHelpAction: {
                    routeId: ROUTE.ACCOUNT_DETAILS,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_accountDetails_goBack' }
                },
                goBackAction: {
                    routeId: ROUTE.ACCOUNT_DETAILS,
                    type: ACTION.BACK_BUTTON,
                    payload: { id: 'bt_accountDetails_goBack' }
                },
                action: {
                    type: ACTION.LOGIN_ACTION,
                    routeId: ROUTE.ACCOUNT_DETAILS,
                    payload: {},
                },
                otpAction: {
                    routeId: ROUTE.ACCOUNT_DETAILS,
                    type: ACTION.RE_LOGIN_ACTION,
                    payload: {},
                },
                editAction: {
                    routeId: ROUTE.ACCOUNT_DETAILS,
                    type: ACTION.EDIT_DETAILS,
                    payload: {}
                },
                handleCloseModalAction: {
                    routeId: ROUTE.ACCOUNT_DETAILS,
                    type: ACTION.CLOSE_MODAL,
                    payload: {}
                },
                handleCloseOtpModalAction: {
                    routeId: ROUTE.ACCOUNT_DETAILS,
                    type: ACTION.CLOSE_OTP_MODAL,
                    payload: {}
                },
                profileName: formattedFullName,
                mobileNumber: `${profileData?.phoneNumber?.substring(0, 3)} ${profileData?.phoneNumber?.substring(3, profileData?.phoneNumber?.length)}`,
                emailId: `${profileData?.emailId}`,
                panNumber: maskSensitiveDetails(`${profileData?.panNumber}`, 0, 4),
                bankImageUri: getBankPNGUrl(profileData?.bankDetails?.bankCode),
                bankName: `${profileData?.bankDetails?.bankName}`,
                ifscCode: `${profileData?.bankDetails?.ifscCode}`,
                bankAccountNumber: maskBankSensitiveDetails(`${profileData?.bankDetails?.accountNumber}`, profileData?.bankDetails?.accountNumber?.length - 4),
                contactUsDetails: contactUsDetails,
                isDarkMode: false,
                state: InputStateToken.DEFAULT,
                charLimit: 6,
                keyboardType: KeyboardTypeToken.numberPad,
                caption: { error: "Enter a 10 digit mobile number" },
                otpModal: false,
                errorModal: false,
                showUsersEditIcon,
                userUpdatedValue,
                userUpdatedType,
                isUserUpdateDetailsInProgress
            },
        },
    };
};
export const accountDetailsMF = {
    onLoad: async ({ instrumentTrack, getHeight, network }, { profileData }) => {
        instrumentTrack('ACCOUNT_DETAILS_PAGE_VIEWED');
        const user = await SharedPropsService.getUser();
        if (profileData === undefined || profileData === null) {
            const response = await network.get(`${api.userProfile}${user?.linkedBorrowerAccounts[0]?.accountId}`, {
                headers: await getAppHeader(),
            });
            profileData = response?.data;
        }
        const fullName = profileData?.name;
        const formattedFullName = formatFullName(fullName);
        const contactUsDetails = await getContactUsDetails();
        const showUsersEditIcon = await showUserEditDetailsIcon();
        const userUpdatedValue = await SharedPropsService.getUserUpdateValue();
        const userUpdatedType = await SharedPropsService.getUserUpdateType();
        const isUserUpdateDetailsInProgress = await SharedPropsService.getIsUserUpdateDetailsInProgress();
        return Promise.resolve(template(profileData, formattedFullName, contactUsDetails, getHeight(), showUsersEditIcon, userUpdatedValue, userUpdatedType, isUserUpdateDetailsInProgress));
    },
    actions: {
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.EDIT_DETAILS]: editUserDetails,
        [ACTION.LOGIN_ACTION]: verifyOtp,
        [ACTION.RE_LOGIN_ACTION]: resendOtp,
        [ACTION.CLOSE_MODAL]: handleCloseModal,
        [ACTION.CLOSE_OTP_MODAL]: handleCloseOtpModal,
    },
    bgColor: "#FFFFFF",
};
